/**
 * Register the CRM service worker only when the user is on /crm/*.
 * The public site (wtddetailing.ca) stays SW-free.
 */
export function registerCrmSw() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;
  if (!window.location.pathname.startsWith("/crm")) return;

  // Inject the manifest link for PWA install
  let link = document.querySelector('link[rel="manifest"]');
  if (!link) {
    link = document.createElement("link");
    link.rel = "manifest";
    document.head.appendChild(link);
  }
  link.href = "/manifest-crm.json";

  // Set theme color for iOS/Android PWA install
  let meta = document.querySelector('meta[name="theme-color"]');
  if (!meta) {
    meta = document.createElement("meta");
    meta.name = "theme-color";
    document.head.appendChild(meta);
  }
  meta.content = "#0c0c0f";

  // Apple mobile web app capable — makes it feel native when added to home
  const ensure = (name, content) => {
    let m = document.querySelector(`meta[name="${name}"]`);
    if (!m) { m = document.createElement("meta"); m.name = name; document.head.appendChild(m); }
    m.content = content;
  };
  ensure("apple-mobile-web-app-capable", "yes");
  ensure("apple-mobile-web-app-status-bar-style", "black-translucent");
  ensure("apple-mobile-web-app-title", "WTD CRM");

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw-crm.js", { scope: "/crm/" })
      .catch((e) => console.warn("SW registration failed", e));
  });
}
